$(function() {
  var step = 0;
  var stepItem = $(".step-content-body");
  var $cesStepBack = $(".ces-step-back");
  $cesStepBack.addClass("out");

  // Step Next
  $(".ces-step-next").on("click", function(e) {
    e.preventDefault();
    var instance = $(this);
    if (stepItem.length - 1 < step) {
      return;
    }
    $(".ces-step-back").removeClass("out");
    if (step === stepItem.length - 2) {
      instance.addClass("out");
      instance.siblings(".ces-step-end").removeClass("out");
    }
    $(stepItem[step]).addClass("active");
    $(".step-content-body").addClass("out");
    step++;
    $(stepItem[step]).removeClass("out");
    if (stepItem[step] !== stepItem[0]) {
      $("#step-search").addClass("d-none");
    }
  });

  // Step Last
  $(".ces-step-end").on("click", function() {
    if (step === stepItem.length) {
      return;
    }
    $(stepItem[stepItem.length - 1]).addClass("active");
    $(".step-content-body").addClass("out");
    $("#stepLast").removeClass("out");
    step++;
  });

  // Step Previous
  $cesStepBack.on("click", function() {
    if (step - 1 < 0) {
      $(".menu-trigger-2").attr("style", "z-index: 1001");
      var $searchVehicleForm = $("#search-vehicle-form");
      $searchVehicleForm.removeClass("slideInLeft");
      $searchVehicleForm.addClass("d-none");
      // and open navigation
      $("#nav-icon").toggleClass("open");
      $("#main-nav")
        .removeClass("d-none")
        .removeClass("slideOutLeft");

      return;
    }
    step--;
    var instance = $(this);
    if (step <= stepItem.length - 1) {
      instance.siblings('button[name="next"]').removeClass("out");
      instance.siblings('button[name="finish"]').addClass("out");
    }
    $(".step-content-body").addClass("out");
    $(stepItem[step]).removeClass("out");
    if (step === 0) {
      stepItem.removeClass("active");
    } else {
      stepItem.filter(":gt(" + (step - 1) + ")").removeClass("active");
    }
    if (step - 1 < 0) {
      $(".ces-step-back").addClass("out");
    }
    if (stepItem[step] === stepItem[0]) {
      $("#step-search").removeClass("d-none");
    }
  });
});

// Select all
$(function() {
  var stepDiv = $(".step-border .col-11");
  stepDiv.on("click", function() {
    $(this)
      .siblings(".d-flex")
      .find("input")
      .trigger("click");
  });
  var width = $(window).width();
  if (width >= 922) {
    $(".step-border .d-flex").on("click", function() {
      $(this)
        .find("input")
        .trigger("click");
    });
    $(".car-check-p").on("click", function() {
      var input = $(this).siblings("input");
      input.trigger("click");
    });
  }
});
$(function() {
  var allModels = $(
    "#citycar,#sedan,#van,#deportivo,#electricos,#camioneta,#comercial,#hatchback,#suv,#stationwagon"
  );
  var allBrands = $("#suzuki,#mazda,#renault,#changan,#gwm,#haval,#jac");
  var allTrans = $("#mec,#aut");
  var allGc = $("#gas,#diesel");
  var inp = $(".inp-car-check:not('.all-inp')");

  renderChecked(inp);

  inp.on("click", function() {
    renderChecked();
    $(this)
      .parent()
      .parent()
      .toggleClass("checked");
  });

  function renderChecked(input) {
    var selected = $("#collapseOne .step-border input:checked")
      .map(function(i, el) {
        return el.dataset.name;
      })
      .get();
    if (selected.length === 0) {
      $("#car-value").html(
        "<span>" + "Selecciona una o más opciones" + "<span/>"
      );
    } else {
      $("#car-value").html("<span>" + selected.join(", ") + "<span/>");
    }

    var selectedBrand = $("#collapseTwo .step-border input:checked")
      .map(function(i, el) {
        return el.dataset.name;
      })
      .get();
    if (selectedBrand.length === 0) {
      $("#brand-value").html(
        "<span>" + "Selecciona una o más opciones" + "<span/>"
      );
    } else {
      $("#brand-value").html("<span>" + selectedBrand.join(", ") + "<span/>");
    }
  }

  $("#all-model").click(function() {
    $("#step01 .step-border").toggleClass("checked", $(this).prop("checked"));
    allModels.prop("checked", $(this).prop("checked"));
  });

  $("#all-brand").click(function() {
    $("#step02 .step-border").toggleClass("checked", $(this).prop("checked"));
    $("#all-brand").prop("checked", $(this).prop("checked"));
    allBrands.prop("checked", $(this).prop("checked"));
    allBrands.prop("checked", $("#prev-brand").toggleClass("d-none"));
  });

  $("#all-trans").click(function() {
    $("#step03 .step-border").toggleClass("checked", $(this).prop("checked"));
    $("#all-trans").prop("checked", $(this).prop("checked"));
    allTrans.prop("checked", $(this).prop("checked"));
  });

  $("#all-gc").click(function() {
    $("#step04 .step-border").toggleClass("checked", $(this).prop("checked"));
    $("#all-gc").prop("checked", $(this).prop("checked"));
    allGc.prop("checked", $(this).prop("checked"));
  });
});
